<template>
  <div class="register">

    <nav-pc :showWap="true"></nav-pc>
    <section>

      <div class="reg-tip">

        <div class="flow-pc">
          <span class="reg-tip-title" v-if="pathName==='tips'">{{lang.f_step}}</span>
          <span class="reg-tip-title" v-else>{{lang.newUser}}</span>
        </div>

        <ul class="reg-tip-list forget-list" v-if="pathName==='tips'">
          <li v-if="type!=='error'&&type!='success'&&type!=4">
            <svg class="icon icon-success" aria-hidden="true">
              <use xlink:href="#icon-success"></use>
            </svg>
            <span v-if="type==1" v-html="email" class="tips-email"></span>
            <span v-if="type==2">{{lang.f_send}}</span>

          </li>
          <li class="go-login" v-if="type!=='error'&&type!='success'&&type!=4">
            <router-link to="/login">
              <van-button type="danger">{{lang.goLogin}}</van-button>
            </router-link>
          </li>
          <li v-if="type=='error'">
            <svg class="icon icon-success" aria-hidden="true" style="opacity:0">
              <use xlink:href="#icon-fail"></use>
            </svg>
            <span class="tips-email">{{lang.link}}</span>
          </li>
          <li v-if="type==4">
            <svg class="icon icon-success" aria-hidden="true" style="opacity:0">
              <use xlink:href="#icon-fail"></use>
            </svg>
            <span class="tips-email">{{lang.forget_error}}</span>
          </li>
          <li class="go-login" v-if="type==4">
            <router-link to="/account/forget">
              <van-button type="danger">{{lang.findPwd}}</van-button>
            </router-link>
          </li>
          <!-- 密码重置成功、认证成功 -->
          <li v-if="type=='success'">
            <svg class="icon icon-success" aria-hidden="true">
              <use xlink:href="#icon-success"></use>
            </svg>
            <span class="tips-email">{{lang.set_success}}<router-link to="/login/" class="verify-login">{{lang.login}}</router-link></span>
          </li>
        </ul>
        <ul class="reg-tip-list forget-list" v-if="pathName==='verify'&&emailPass&&hasVerify">
          <!-- 邮箱验证已经通过 -->
          <li>
            <svg class="icon icon-success" aria-hidden="true">
              <use xlink:href="#icon-success"></use>
            </svg>
            <span>1.Email {{lang.email+(lang.confirm || lang.save)}}({{mailAdress}})：<span class="verify-login">{{lang.pass}}</span></span>
          </li>
          <!-- 验证手机号 -->
          <li v-if="!phoneSuccess">
            <svg class="icon icon-success" aria-hidden="true" style="opacity:0">
              <use xlink:href="#icon-fail"></use>
            </svg>
            <span>2.Phone {{lang.tel+(lang.confirm || lang.save)}}：{{lang.waitPass}}</span>
          </li>
          <li v-if="phoneSuccess">
            <svg class="icon icon-success" aria-hidden="true">
              <use xlink:href="#icon-success"></use>
            </svg>
            <span>2.Phone {{lang.tel+lang.save}}：<span class="verify-login">{{lang.pass}}</span></span>
          </li>
          <!-- 发送验证码 -->
          <li class="list-code list-verify-right" v-if="!phoneSuccess">
            <span class="reg-title"> </span> <input type="text" @input="checkInt('smsCode')" maxlength="4" :placeholder="lang.enter+lang.smsCode" v-model="smsCode">
            <button class="ver-send-btn ver-resend" @click="sendCode">{{count>0?`${lang.reSend}(${count})`:sendCount==0?lang.sendMg:lang.reSend}}</button>
          </li>
          <li class="list-verify-right" v-if="!phoneSuccess">
            <van-button class="ver-send-btn ver-code" type="danger" @click="verCode" :loading-text="lang.f_wait" :loading="isWait">{{lang.save}}</van-button>
            <div class="ver-error" v-show="showError">{{errorText}} </div>
          </li>
          <li class="list-verify-right lightgray" v-html="lang.smsTip" v-if="!phoneSuccess">

          </li>
          <li class="list-verify-right">
            <label class="verify-pass">{{lang.verifyPass}}<router-link to="/login/" class="verify-login">{{lang.login}}</router-link></label>
          </li>

        </ul>
        <!-- //邮箱验证未通过  重发验证讯息-->
        <ul class="reg-tip-list forget-list" v-if="pathName==='verify'&&!emailPass&&hasVerify&&$route.query.type!=3">
          <li>
            <svg class="icon icon-success" aria-hidden="true" style="opacity:0">
              <use xlink:href="#icon-fail"></use>
            </svg>
            <span>{{lang.accountStatus}}（{{mailAdress}}）：<span class="verify-login">{{lang.waitPass}}</span>
              <span class="verify-notrue" v-if="!$route.query.key">{{lang.noTrue}}</span>
              <span class="verify-notrue" v-else>{{lang.link}}</span>
            </span>
          </li>
          <li class="list-verify-right">
            <van-button v-show="!hasPass" type="danger" @click="sendEmail" :loading-text="lang.f_wait" :loading="isWait">{{lang.reSend}}</van-button>
            <router-link v-show="hasPass" to="/login">
              <van-button type="danger">{{lang.goLogin}}</van-button>
            </router-link>
            <span class="ver-error" v-show="hasPass">{{lang.hasPass}}</span>
            <!-- <label class="verify-pass">{{lang.send}}</label>
               <label  class="send-msg-tip">{{lang.reSend}}</label>
                -->
          </li>
        </ul>

        <!-- //待验证账户提示-->
        <ul class="reg-tip-list forget-list" v-if="!hasSendEmail&&$route.query.type==3">
          <li>
            <svg class="icon icon-success" aria-hidden="true" style="opacity:0">
              <use xlink:href="#icon-fail"></use>
            </svg>
            <span>{{lang.accountStatus}}（{{mailAdress}}）：{{lang.waitPass}}
              <span class="verify-notrue">{{lang.waitSend}}</span>
            </span>
          </li>
          <li class="list-verify-right">
            <van-button v-show="!hasPass" type="danger" @click="sendEmail" :loading-text="lang.f_wait" :loading="isWait">{{lang.reSendEmail}}</van-button>
            <router-link v-show="hasPass" to="/login">
              <van-button type="danger">{{lang.goLogin}}</van-button>
            </router-link>
            <span class="ver-error" v-show="hasPass">{{lang.hasPass}}</span>
            <!-- <label class="verify-pass">{{lang.send}}</label>
               <label  class="send-msg-tip">{{lang.reSend}}</label>
                -->
          </li>
        </ul>

      </div>
    </section>

  </div>
</template>

<script>
import { Button } from "vant";
// import "vant/lib/button/style";
import lang from "./../../common/language/register";
import navBar from "./../components/navBar";
import navPc from "./../components/navBar-pc";

export default {
  metaInfo () {
    return {
      title: lang.verinfo
    }
  },
  name: "register",
  data () {
    return {
      hasSendEmail: false,
      sendCount: 0,
      hasPass: false,
      phoneSuccess: false,
      showError: false,
      isWait: false,
      emailPass: true,
      type: -1,
      lang: lang,
      email: "",
      pathName: "",
      count: 0,
      timer: null,
      smsCode: "",
      errorText: "",
      mailAdress: "",
      hasVerify: false,
      cacheNum: "",
    };
  },
  created () {
    this.init();
  },


  methods: {
    init () {
      this.mailAdress = this.$route.query.email;
      this.pathName = this.$route.name;
      if (this.pathName === "verify") {
        //验证key是否有效
        this.axios.get(this.pub.getApi().VerifyRegisterKey, { params: { key: this.$route.query.key } }).then(res => {
          this.hasVerify = true;
          if (res.data.code === 1315) this.emailPass = false;
        })

      } else {
        //显示发送成功讯息提示
        lang.phone = lang.telephone;
        this.type = this.$route.query.type;
        this.$route.query.email && (this.email = this.lang.f_success.replace("@", this.$route.query.email))
      }

    },
    //重新发送验证邮件
    sendEmail () {
      this.isWait = true;
      this.axios.post(this.pub.getApi().SendUserVerifyInfo, { email: this.$route.query.email }).then(res => {
        this.isWait = false;
        if (res.data.code === 0) {
          this.$router.push("/account/tips/?type=1&email=" + this.$route.query.email);
          this.hasSendEmail = true;
          this.init();

        } else if (res.data.code == 1323)
          this.hasPass = true;


      })
      setTimeout(() => { this.isWait = false; }, 3000);
    },
    //发送短信验证码
    sendCode () {
      if (this.timer) return;
      this.axios.get(this.pub.getApi().GetRegisterVerifySms, { params: { key: this.$route.query.key } }).then(res => {
        this.sendCount++;
        if (res.data.code === 0) {
          this.count = 120;
          this.timer = setInterval(() => {
            //  console.log(this.timer,this.count)
            if (this.count >= 1) this.count--;
            else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      })
    },
    verCode () {
      this.showError = false;
      if (!this.smsCode) {
        this.errorText = lang.null + lang.smsCode;
        this.showError = true;
        return;
      }
      //验证短信code
      this.axios.get(this.pub.getApi().RegisterVerifySms, { params: { key: this.$route.query.key, smsCode: this.smsCode } }).then(res => {
        if (res.data.code !== 0) {
          if (res.data.code == 1322) this.errorText = lang.smsCode + lang.noPass;
          else this.errorText = lang.smsCode + lang.error;
          this.showError = true;
        } else {
          this.phoneSuccess = true;
        }

      })
    },
    //检测数字
    checkInt (field, type) {
      const num = this[field];
      (/^$|^\d+$/).test(num) ? this.cacheNum = num : this[field] = this.cacheNum;
      // if(num&&(num[0]==0||num[0]==1))this[field]=num.replace(num[0],"");
    },

  },
  components: {
    [Button.name]: Button,
    navBar,
    navPc
  }
};
</script>

<style  lang="scss" >
.icon-success,
.icon-fail {
  font-size: 26px;
  color: #ec404e;
  margin-right: 6px;
}
.register {
  min-height: 100%;
  background-color: #f8f8f8;

  section {
    width: 100%;
  }
}

.list-code {
  span {
    white-space: nowrap;
  }
  input {
    width: 24%;
    min-width: 165px;
    font-size: 15px;
  }
}
.reg-tip {
  padding: 70px 0;
  border-radius: 5px;
  padding: 18px 0px;
  // background: rgba(255,255,255,.8);
  margin: auto;
  max-width: 990px;
  background: white;

  .reg-tip-title {
    font-size: 25px;
    font-weight: 600;
    color: #ec404e;
    margin-bottom: 14px;
    display: block;
  }
  .ver-error {
    color: red;
    padding-left: 10px;
    line-height: 44px;
  }
  .reg-tip-list li {
    text-align: left;
    line-height: 25px;
    padding-right: 20px;
    span {
      font-size: 17px;
      letter-spacing: 2px;
      word-break: break-all;
    }
  }
}
.reg-tip {
  display: none;
}

.send-msg-tip {
  color: #ec404e;
  margin-left: 10px;
  font-size: 14px;
}
.reg-tip {
  // min-width: 800px;
  min-height: 400px;
  display: block;
  padding: 30px;
  box-sizing: border-box;
}
.ver-send-btn {
  margin-top: 0px !important;
  min-width: 120px;
}
.ver-resend {
  border: none;
  background: #dadada;
  border-radius: 3px;
  padding: 4px;
  margin-left: 10px !important;
}

.tips-email a {
  color: #4594e6;
  // text-decoration-line: underline;
  cursor: pointer;
}
.forget-list {
  margin-top: 30px;
  li {
    margin-top: 10px;
    display: flex;
    word-break: break-all;
    align-items: flex-start;
    svg {
      flex: 0 0 28px;
    }
    input {
      height: 29px;
      border-radius: 3px;
      border: solid 1px lightgray;
    }
  }
}
.verify-pass {
  background: #fff1e2;
  color: #656260;
  padding: 8px 15px;
  border-radius: 4px;
  margin-top: 10px;
  display: inline-block;
}
.verify-login {
  color: #2884ea;
  padding-left: 10px;
  cursor: pointer;
}
.lightgray {
  color: #b3b3b3;
}
.verify-notrue {
  display: block;
  color: #2884ea;
  margin-top: 13px;
  cursor: pointer;
}
.list-verify-right {
  position: relative;
  left: 32px;
  button {
    margin: 0px;
  }
}
.go-login a {
  display: flex;
  position: relative;
  top: -14px;
  left: 30px;
}
</style>
